export const AVATAR_TYPE = {
  GOBUYSIDE: 'GoBuyside',
  USER: 'User',
  FIRM: 'Firm',
  JOB: 'Job',
  DEFAULT: 'default',
};

export default AVATAR_TYPE;
